import { I18n } from '@lingui/core'
import { Trans, withI18n } from '@lingui/react'
import {
  type Dispatch,
  type ReactElement,
  type SetStateAction,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { updateNowDataSuccessAction } from 'shared/store/ducks/now/actions'
import { type IState, type NowDataState } from 'types/redux'
import Button from 'views/components/atoms/Button'
import Image from 'views/components/atoms/Image'
import InputTextWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'
import Modal from 'views/components/molecules/Modal'
import nowLogo from 'views/components/organisms/Cart/NowCollapsible/now_logo.svg'
import './NowZipModalGreenVariant.scss'

interface INowZipModalGreenVariantProps {
  id: string
  open: boolean
  i18n: I18n
  setModalOpen: Dispatch<SetStateAction<boolean>>
  zip: string
}

const NowZipModalGreenVariant: (
  props: INowZipModalGreenVariantProps
) => ReactElement = ({ id, open, setModalOpen, zip, i18n }) => {
  const dispatch = useDispatch()
  const nowData: NowDataState = useSelector(
    (state: IState) => state.nowData
  ) as NowDataState
  const [currentZipValue, setCurrentZipValue] = useState('')

  const clickStoreZipButton = () => {
    if (!currentZipValue) {
      dispatch(updateNowDataSuccessAction({}))
    } else {
      dispatch(
        updateNowDataSuccessAction({
          ...nowData,
          zipCode: currentZipValue,
        })
      )
    }
    setModalOpen(false)
  }

  useEffect(() => {
    setCurrentZipValue(zip)
  }, [zip])

  return (
    <>
      {open ? (
        <Modal
          id={id}
          title={i18n._('general.label.nowGlobalBar.chooseLocation')}
          size="medium"
          light
          open={open}
          isClientSideControlled
          onHideModal={() => {
            setModalOpen(false)
          }}
        >
          <div>
            <div>
              <Trans id="general.label.nowGlobalBar.modalDescription" />
            </div>
            <div className="o-NowZipModalGreenVariant-NowInformationWrapper">
              <div className="o-NowZipModalGreenVariant-NowInformationWrapperTitle">
                <Image
                  className="u-margin--small u-padding-small--right o-NowGlobalBarContentGreenVariant__nowLogo"
                  src={nowLogo}
                />
                <strong>
                  <Trans id="general.label.nowGlobalBar.nowAvailability" />
                </strong>
              </div>
              <div>
                <Trans id="general.label.nowGlobalBar.nowAvailabilityDescription" />
              </div>
            </div>
            <div>
              <Trans id="general.label.nowGlobalBar.enterZip" />
            </div>
          </div>
          <div className="o-NowZipModalGreenVariant-input-wrapper">
            <InputTextWithFloatingLabel
              placeholder={i18n._('general.label.nowGlobalBar.yourZip')}
              name="zip"
              defaultValue={zip}
              onChange={e => setCurrentZipValue(e.target.value)}
            />
          </div>
          <Button name="storeZip" onClick={clickStoreZipButton}>
            <Trans id="general.label.nowGlobalBar.confirm" />
          </Button>
        </Modal>
      ) : null}
    </>
  )
}

export default withI18n()(NowZipModalGreenVariant)
